import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import { Form } from 'antd'
import { Container, Col, Row } from 'react-bootstrap'
import { Typography } from '@mui/material'
import moment from 'moment'

import useFetchData from 'Shared/Hooks/useFetchData'
import { DatetimePicker, CheckList, Dropdown, TextInput, FormContainer, DatePicker, Checkbox, TimePicker } from 'Shared/Components/FormComponents'
import { showSuccess } from 'Shared/Components/NotifyToast'
import { apiUrl } from 'Shared/utils'
import useCommonAPI from 'Shared/API/Common'
import BackLinkButton from 'Shared/Components/BackLinkButton'

const PermitToWorkCreate = () => {
  const [form] = Form.useForm()
  const { form_id, template_id } = useParams()
  const { send } = useFetchData()
  const navigate = useNavigate()
  const { getWorkers } = useCommonAPI()
  const { organization, project } = useParams()
  const { setPageLoading } = useOutletContext()

  const [workers, setWorkers] = useState({})
  const [formTemplateDetail, setFormTemplateDetail] = useState({})
  const [floorplanList, setFloorplanList] = useState([])
  const [lockDevices, setLockDevices] = useState([])

  const [start, setStart] = useState(false)

  const getFormTemplateDetail = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/permit_to_work/template_detail`,
      params: {
        "template_id": template_id
      },
      returnType: "json"
    })

    setFormTemplateDetail(body)

    if (body["type"] == "confined_space") {
      await fetchFloorPlan()
    }
    else if (body["type"] == "switch_box") {
      await fetchLockDevices()
    }
  }

  const fetchFloorPlan = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/smartwatch/floorplan_meta`,
      returnType: "json"
    })

    setFloorplanList(body.map((i) => ({
      "value": i["location"],
      "label": i["location_name"],
    })))
  }

   const fetchLockDevices = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/smart_lock/devices`,
      params: {
        require_permit: 1
      },
      returnType: "json"
    })

    setLockDevices(body.map((i) => ({
      "value": i["device_id"],
      "label": i["device_name"],
    })))
  }

  const loadWorkers = async () => {
    const body = await getWorkers()

    setWorkers(body["data"].map((i) => ({
      "value": i.worker_id,
      "label": i.worker_name
    })))
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await Promise.all([
        getFormTemplateDetail(),
        loadWorkers()
      ])

      setStart(true)
      setPageLoading(false)
    }

    init()
  }, [])

  const onFinish = async (values) => {
    setPageLoading(true)

    const res = await send({
      method: "POST",
      url: `${apiUrl}/permit_to_work/form/${template_id}`,
      contentType: "json",
      body: {
        "workers": values["workers"],
        "company": values["company"],
        "confined_space_location": values["confined_space_location"],
        "work_location": values["work_location"],
        "work_description": values["work_description"],
        "permit_start_time": values["permit_start_time"] ? moment(new Date(values["permit_start_time"])).format("YYYY-MM-DD HH:mm:ss") : null,
        "permit_end_time": values["permit_end_time"] ? moment(new Date(values["permit_end_time"])).format("YYYY-MM-DD HH:mm:ss") : null,
        "permit_date": values["date"] ? moment(new Date(values["date"])).format("YYYY-MM-DD") : null,
        "duration": `${values["duration"] ? moment(new Date(values["duration"][0])).format("HH:mm:ss") : null}|${values["duration"] ? moment(new Date(values["duration"][1])).format("HH:mm:ss") : null}`,
        "devices": values["devices"]
      }
    })

    if (res != null) {
      showSuccess("Form created")
      navigate(`/portal/${organization}/${project}/permit_to_work/list`)
    }

    setPageLoading(false)
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", paddingLeft: 0, paddingRight: 0, display: "flex", flexFlow: "column"  }}>
          <div>
            <BackLinkButton />
          </div>

          {start &&
            <div style={{ flexGrow: 1, overflow: "auto", margin: "10px" }}>
              <FormContainer form={form} onFinish={onFinish} initialValues={{}}>
                <div style= {{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
                  <Typography variant="h6" component="h2">
                    <u>{formTemplateDetail["template_name"]}</u>
                  </Typography>
                </div>

                <div>
                  <Dropdown field_name="Workers" field_id="workers" props={{ "multiple": true, "options": workers }} required/>
                  <TextInput field_name="Company" field_id="company" required />

                  {formTemplateDetail["type"] == "confined_space" ? (
                    <Dropdown field_name="Work Location" field_id="confined_space_location" props={{ "multiple": false, "options": floorplanList }} required />
                  ) : (
                    <TextInput field_name="Work Location" field_id="work_location" required />
                  )}

                  <TextInput field_name="Work Description" field_id="work_description" required/>

                  {formTemplateDetail["type"] == "switch_box" && <>
                    <Dropdown field_name="Devices" field_id="devices" props={{ "multiple": true, "options": lockDevices}} required />
                  </>}

                  <DatePicker field_name="Date" field_id="date" required props={{ "type": "date" }} />
                  <TimePicker field_name="Permit Duration" field_id="duration" required props={{ "range": true }} />
                </div>
              </FormContainer>
            </div>
          }
        </Col>
      </Row>
    </Container>
  </>)
}

export default PermitToWorkCreate
